// Zod 4's JIT compiler uses `new Function()`, which violates our CSP `script-src 'self'` policy.
// Disabling JIT must happen before any module that creates a zod schema is loaded.
// Using a dynamic import for the bootstrap module ensures all transitive dependencies
// (which may call z.object() at module scope) are evaluated AFTER jitless is set.
import { handleBootstrapError } from "@fideus/chunk-error-recovery";
import { config } from "zod";

config({ jitless: true });

void import("./bootstrap").catch(handleBootstrapError);
